import { FilterDrawer } from './FilterDrawer'
import { FilterSort } from './FilterSort'
import { ResultCount } from './ResultCount'

export function FilterBarMobile() {
  return (
    <div class="flex w-full items-center justify-between px-6 py-4 md:hidden">
      <FilterDrawer />
      <ResultCount className="absolute left-0 right-0 flex-grow text-center pointer-events-none text-neutrals-tertiary-grey" />
      <FilterSort name={'mobile_sort'} />
    </div>
  )
}
